import * as _ from "lodash";
import * as React from "react";
import { connect } from "react-redux";
import IFrequency from "../../../../server/models/UIModels/commons/IFrequency";
import { GenericActions } from "../../actions/GenericActions";
import SuggestionTagsContainer, { SuggestionItem } from "../../containers/SuggestionTagsContainer";
import IQuestionnaire, { ITrackingConfig, ITrackingEvent, Question } from "../../models/util/IQuestionnaire";
import { AppConstants, FieldTypes, FormItemMode, QuestionType, DoctorType } from "../../utils/AppConstants";
import AppUtils from "../../utils/AppUtils";
import ValidationUtils from "../../../../common/utils/ValidationUtils";
import AdvancedDurationComponent from "../AdvancedDurationComponent";
import CollapsiblePanel from "../CollapsiblePanel";
import CustomSelect from "../CustomSelect";
import Input from "../TextInput";
import ToggleList, { default as ToggleButtonList } from "../ToggleButtonList";
import TypeAhead, { TypeAheadElement } from "../TypeAhead";
import TimePicker from "../TimePicker";
import HorizontalTagsListViewTypeAhead from "../HorizontalTagsListViewTypeAhead";
import SliderComponent from "../patient/edit/SliderComponent";
import TemplatedList from "../TemplatedList";
import TextAreaAutoResize from "../TextAreaAutoResize";
import TemplatedListHeaders from "../utils/TemplatedListHeaders";
import QuestionnaireList from "./QuestionnaireList";
import TextareaAutosize from "react-autosize-textarea/lib/TextareaAutosize";
import EditorAndViewContainer from "../../containers/EditorAndViewContainer";
import ToggleSwitch from "./ToggleSwitch";
import { Tracker } from "../../utils/Tracker";
import { EventNames, SectionContext, UnregisterKeys, FlowContext } from "../../utils/EventTrackerConstants";
import TreatmentPlanComponent from "../TreatmentPlanComponent";
import ITreatmentPlanTemplateResponseObj, { ITemplateInfo } from "../../models/ITreatmentPlanTemplateResponse";
import { IAppointmentScheduleResponse, IMedicinePrescription } from "@curefit/care-common";
import IAppointmentSchedule from "../../models/IAppointmentSchedule";
import Frequency from "../DurationComponent";
import { SpacingArea, RenderLabel, ToggleSelect } from "./ToggleSelect";
import { IConsultaionMap } from "../../models/patients/IPatientCompleteInfo";
import IStaticDataValue from "../../../../common/models/IStaticDataValue";
import { MedicineBrandName } from "../../models/prescription/MedicineBrandName";
import ILabTest from "../../models/ILabTest";
import { IPrescription } from "@curefit/care-common";
import RichTextEditor from "./RichText/RichTextEditor";
import { IAppState } from "../../models/IAppState";
import { MedicineFrequencyType } from "../../models/Consultation";
import { OngoingConsultationActions } from "../../actions/OngoingConsultationActions";
import { filter } from "minimatch";
import { EHRRequestMapper } from "../../api/EHRRequestMapper";
import { MedicineFrequencyType } from "../../models/Consultation";
import IDoctorProfile from "../../models/IDoctorProfile";
import LocalStorageUtils from "../../utils/LocalStorageUtils";
import TemplatedListV3 from "../TemplatedListV3";

export interface MetaData {
    sectionKey: string
}

interface QuestionnaireStateProps {
    doctorType: string,
    usedSuggestionsForEditorMap: { [key: string]: string[] }
    pastConsultaions: IPrescription[];
    doctorProfile: IDoctorProfile;
}

interface QuestionnaireProps {
    metaData?: MetaData
    question: IQuestionnaire;
    answer: any;
    validations?: any;
    updateHandler?: (value: any, key: string) => void;
    validationHandler?: (value: any, key: string) => void;
    templatedListValidations?: (value: any, index: number, key: string) => void;
    hideComment?: boolean;
    onTypeHeadChangeHandler?: any;
    typeAheadString?: string;
    onTypeAheadSelect?: (input: TypeAheadElement, key: string) => void;
    onToggleSelect?: (toggleState: boolean) => void;
    onListItemRemove?: (index: number, key: string) => void;
    minWidth?: number
    templatedListChange?: (updatedValue: any, index: number, key: string) => void;
    templatedListRemoved?: (index: number, key: string) => void;
    validator?: any;
    defalutToggleSelect?: boolean;
    validationText?: string;
    supportDecimal?: boolean;
    className?: string;
    onDataChange?: (update: any) => any;
    isViewOnly?: boolean;
    modalHeaders?: any[];
    fetchPatientPastSessions?: (patientId: number, subSectionKey: string) => Promise<any>;
    patientId?: number;
    subSectionKey?: string;
    onAddNewItem?: (patientId: number, subSectionKey: string, extraData?: any) => void;
    addSymptomForReview?: (name: string) => Promise<any>;
    addButtonClicked?: (status: boolean, name: string) => Promise<any>;
    responseData?: any;
    modalResponse?: any;
    complaints?: any;
    suggestions?: { [key: string]: any };
    targetKey?: string,
    targetValue?: any,
    updateTemplatedListData?: (listData: { item: any, mode: FormItemMode }[], questionKey: string) => void,
    validationSchema?: any,
    updatedObject?: any,
    emptyText?: string,
    onTreatmentPlanSelect: (template: ITreatmentPlanTemplateResponseObj, updatedObject: any, key: string) => void,
    appointmentSchedule?: IAppointmentSchedule,
    fetchDataOnSelect: (diagnosis?: Array<string>) => void,
    allQuestionsConfig: IQuestionnaire[]
    onUndoApplyTreatmentPlan?: (callback: Function, removedTemplate?: ITemplateInfo) => void,
    getSuggestionsSequentially?: () => void;
    hideDeleteAndAddOption?: boolean;
}

interface IMapDispatch {
    getTypeAheadData?: (name: string, typeAheadConfig: any) => Promise<any>;
    addUsedSuggestionForEditor: (subSectionKey: string, val: string) => void

}

interface QuestionnaireDispatchProps {
    getTypeAheadData?: (name: string, typeAheadConfig: any) => Promise<any>;
    addUsedSuggestionForEditor: (subSectionKey: string, questionKey: string, val: string) => void
    pastConsultaions: IPrescription[];
}

let listValue = true;
interface QuestionnaireState {
    defalutToggleSelect: boolean;
    key: string;
    isDisable: boolean;
    isActiveMedicationVisible: boolean;
    noOfStroke: number
}

class Questionnaire extends React.Component<QuestionnaireProps & QuestionnaireDispatchProps & QuestionnaireStateProps, QuestionnaireState> {
    constructor(QuestionnaireProps: any) {
        super(QuestionnaireProps);
        this.state = { defalutToggleSelect: false, key: null, isDisable: true, isActiveMedicationVisible: false, noOfStroke: 0 }
    }

    static contextType = SectionContext; // registering context type

    booleanToggleHandler = (selectedBtn: any, key: string) => {
        let updatedInfo = { ...this.props.answer };
        if (selectedBtn === null) {
            delete updatedInfo[key];
        } else {
            let answer = selectedBtn;
            if (AppUtils.isDefined(this.props.question.answerList[0].subKey)) {
                let obj: any = {};
                let keyName = this.props.question.answerList[0].subKey;
                obj[keyName] = selectedBtn;
                answer = obj;
            }
            updatedInfo[key] = answer;
        }
        this.props.updateHandler(updatedInfo, this.props.question.key);
    }

    countChangeHandler = (e: any, key: string) => {
        let updatedInfo = { ...this.props.answer };
        updatedInfo[key] ? updatedInfo[key].count = e.target.value : updatedInfo[key] = { count: e.target.value };
        this.props.updateHandler(updatedInfo, this.props.question.key);
    }

    unitChangeHandler = (value: string, key: string) => {
        let updatedInfo = { ...this.props.answer };
        updatedInfo[key] ? updatedInfo[key].unit = value : updatedInfo[key] = { unit: value };
        this.props.updateHandler(updatedInfo, this.props.question.key);
    }

    frequencyChangeHandler = (value: TypeAheadElement, key: string) => {
        let updatedInfo = { ...this.props.answer };
        let validations = { ...this.props.validations };
        updatedInfo[key] = value.others.value;
        this.props.updateHandler(updatedInfo, this.props.question.key);
        if (this.props.validationHandler)
            this.props.validationHandler(validations, this.props.question.key);
    }

    selectHandler = (option: string, key: string) => {
        let updatedInfo = { ...this.props.answer };
        let validations = { ...this.props.validations };
        updatedInfo[key] = option;
        validations = ValidationUtils.checkValidations(updatedInfo, this.props.question.answerList, "key");
        this.props.updateHandler(updatedInfo, this.props.question.key);
        if (this.props.validationHandler)
            this.props.validationHandler(validations, this.props.question.key);
    }

    onChangeHandler = (event: React.SyntheticEvent<HTMLTextAreaElement>, key?: string) => {
        let value = (event.target as HTMLTextAreaElement).value;
        key = key || "comment";
        let updatedInfo = { ...this.props.answer };
        let validations = { ...this.props.validations };
        updatedInfo[key] = value;
        validations = ValidationUtils.checkValidations(updatedInfo, this.props.question.answerList, "key");
        this.props.updateHandler(updatedInfo, this.props.question.key);
        if (this.props.validationHandler)
            this.props.validationHandler(validations, this.props.question.key);
    }

    onChangeRichText = (value: string, key?: string) => {
        key = key || "comment";
        let updatedInfo = { ...this.props.answer };
        let validations = { ...this.props.validations };
        updatedInfo[key] = value;
        validations = ValidationUtils.checkValidations(updatedInfo, this.props.question.answerList, "key");
        this.props.updateHandler(updatedInfo, this.props.question.key);
        if (this.props.validationHandler)
            this.props.validationHandler(validations, this.props.question.key);
    }

    onKeyDown = () => {
        this.setState({ noOfStroke: this.state.noOfStroke + 1 })
    }

    onBlur = (event: any, keyName: string) => {
        const noOfStroke = this.state.noOfStroke
        if (noOfStroke) {
            const value = event && event.target && event.target.value
            this.setState({ noOfStroke: 0 })
            Tracker.track(EventNames.KeyStroke, { value: value, field: keyName, noOfKeystrokes: noOfStroke, widget: this.props.question.key, section: this.context });
        }
    }

    onSliderChange = (value: any, key: string) => {
        let updatedInfo = { ...this.props.answer };
        updatedInfo[key] = value
        this.props.updateHandler(value, this.props.question.key);
    }

    onNumericChangeHandler = (event: any, key: string) => {
        let inputText = event.target.value.toString();
        if (inputText === "" || !isNaN(Number(inputText))) {
            let value = inputText;
            let updatedInfo = { ...this.props.answer };
            updatedInfo[key] = value;

            this.props.updateHandler(updatedInfo, this.props.question.key);
        }
    }

    allSelectToggleHandler = (values: any[] | boolean, key: any, internal: boolean = true) => {
        let updatedInfo = { ...this.props.answer };
        if (!internal && Array.isArray(values) && values.length > 0 && this.state.defalutToggleSelect) {
            this.setState({ defalutToggleSelect: false }) // use as a constant condition
            AppUtils.isDefined(this.state.key) ? updatedInfo[this.state.key] = false : "";
        }

        if (internal) {
            this.setState({ defalutToggleSelect: false }) // use as a constant condition
            AppUtils.isDefined(this.state.key) ? updatedInfo[this.state.key] = false : "";
        }
        else {
            AppUtils.isDefined(this.state.key) ? updatedInfo[this.state.key] = this.state.defalutToggleSelect : "";
        }
        updatedInfo[key] = values;
        this.props.updateHandler(updatedInfo, this.props.question.key);
    }

    allTimeChangeHandler = (value: string, key: string) => {
        let updatedInfo = { ...this.props.answer };
        updatedInfo[key] = AppUtils.getTimeInSeconds(value);
        this.props.updateHandler(updatedInfo, this.props.question.key);
    }

    getFormattedFrequencyUnit = (unit: string) => {
        let unitToDisplay = "";
        if (!_.isEmpty(unit) && !_.isEmpty(AppConstants.FrequencyUnit[unit])) {
            unitToDisplay = AppConstants.FrequencyUnit[unit];
        }
        return unitToDisplay;
    }

    onTimeRangeChangeHandler = (evt: any, key: string) => {
        let value = evt.target.value;
        if (!isNaN(parseInt(value)) || value === "") {
            let updatedInfo = { ...this.props.answer };
            updatedInfo[key] = !isNaN(parseInt(value)) ? parseInt(value) * 60 * 60 : null;
            this.props.updateHandler(updatedInfo, this.props.question.key);
        }
    }

    createNewFields = (dataObj: any = { fields: [] }) => {
        let item: any = {};
        dataObj.fields.map((field: any, index: number) => {
            if (field.key) {
                item[field.key] = ""
                if (field.displayKey) {
                    item[field.displayKey] = ""
                }
            } else if (field.type === FieldTypes.TEMPLATED_LIST || field.type === FieldTypes.TEMPLATED_LIST_V3) {
                item["items"] = [];
            }
        });
        return item;
    }

    updateHandler = (value: any, subkey: string, key: string) => {
        let updatedAnswer = { ...this.props.answer, [subkey]: value };
        this.props.updateHandler(updatedAnswer, key);
    }

    getHeadersInfo = (fields: any, headersInfo: any[]) => {
        let obj: any = null;
        fields.map((field: any, index: number) => {
            if (field.header) {
                obj = {
                    "display": field.header,
                    "textSize": field.textSize
                }
                headersInfo.push(obj);
            }
            if (field.type === FieldTypes.TEMPLATED_LIST || field.type === FieldTypes.TEMPLATED_LIST_V3) {
                this.getHeadersInfo(field.fields, headersInfo);
            }
        })
    }

    onTypAheadChange = (input: string, field: any, allowAnswerUpdare: boolean = true) => {
        // let updatedAnswer = { ...this.props.answer, [field.key]: { displayValue: input, internalValue: input }, [field.displayKey]: { displayValue: input, internalValue: input }}
        if (allowAnswerUpdare) {
            let updatedAnswer = { ...this.props.answer, [field.displayKey]: input, [field.key]: input };
            this.props.updateHandler(updatedAnswer, this.props.question.key);
        }
        let { valueKey, labelKey, additionalInfoLabelKeys, otherKeysMapping } = field.typeAheadConfiguration;
        return this.props.getTypeAheadData(input, field.typeAheadConfiguration).then(resultList => {
            let allergenTypeAhead: TypeAheadElement[] = [];
            _.map(resultList, (obj) => {
                let additionalInfoLabel = (additionalInfoLabelKeys || []).reduce((a: any[], k: string) => {
                    a.push(obj[k]);
                    return a;
                }, [])
                    .join(" | ")
                let others: any = {};
                Object.keys(otherKeysMapping || {}).map((key: string) => {
                    others[key] = obj[otherKeysMapping[key]];
                });
                let typeAheadElement: TypeAheadElement = {
                    value: obj[valueKey],
                    label: obj[labelKey],
                    additionalInfoLabel: additionalInfoLabel,
                    others: others
                }
                allergenTypeAhead.push(typeAheadElement);
            })
            return Promise.resolve({ options: allergenTypeAhead, completed: true });
        }).catch(error => {
            throw error;
        });
    }

    onTypeAheadSelect = (elem: TypeAheadElement, field: any) => {
        let updatedAnswer = { ...this.props.answer, [field.displayKey]: elem.label, [field.key]: elem.value };
        for (let key in elem.others) {
            if (updatedAnswer[key]) {
                updatedAnswer[key] = elem.others[key];
            }
        }
        this.props.updateHandler(updatedAnswer, this.props.question.key);
    }


    /**
     * @description To highlight the status of the toggle button when page is mounted
     * START
     */
    componentDidMount() {
        const getAnswerList = this.props.answer || [];
        let BOOLTYPE_CHECK = "boolean";
        let isSelected = true;
        let getLength = -1;
        try {
            for (const key of Object.keys(getAnswerList)) {

                if (getAnswerList[key] && typeof getAnswerList[key] === "object" || typeof getAnswerList[key] === BOOLTYPE_CHECK) { // Checking for an Object
                    getLength = getAnswerList[key].length;
                    if (getAnswerList[key].length > 0) {
                        this.setState({ defalutToggleSelect: false });
                        isSelected = false;
                    }
                    else if (isSelected) {
                        for (const key of Object.keys(getAnswerList)) {
                            if (typeof getAnswerList[key] === BOOLTYPE_CHECK || (getLength === 0 && getAnswerList[key] === true)) {
                                this.setState({ defalutToggleSelect: getAnswerList[key] || false })
                            }
                        }
                    }
                }
            }
        } catch (e) {
            console.log(e)
        }
    }
    /**
     * @description To highlight the status of the toggle button when page is mounted
     * END
     */




    /**
     * @description For toggling and for Handling the slected List
     * START
     */
    onToggleSelect = async (value: any, key: string) => {

        const selectKeyName = key;
        const selectedValues = !value;
        let updateStatus = false;
        let notSelectedObj = {
            defalutToggleSelect: selectedValues,
            key: selectKeyName
        }
        await this.setState(notSelectedObj);
        /* for togggling the array
        */
        let getAnswerList = this.props.answer || [];
        if (selectedValues) {

            for (const key of Object.keys(getAnswerList)) {

                if (typeof getAnswerList[key] === "object") {
                    updateStatus = true;
                    await this.allSelectToggleHandler([], key, false)  // For updating the props for the Selected List of the element.

                }
            }


        }
        if (!updateStatus) await this.allSelectToggleHandler(selectedValues, selectKeyName, false) // for updating the ToggleList component
    }
    /**
      * @description For toggling and for Handling the slected List
         * END
         */

    onPastDataClick = (data: any) => {
        let updatedAnswerList = !_.isEmpty(this.props.targetValue) ? [...this.props.targetValue] : [];
        let updatedItem = data;
        updatedAnswerList.push(updatedItem);
        this.props.updateHandler(updatedAnswerList, this.props.question.answerList[0].targetFieldParentKey);
    }

    onTemplateAdd = (suggestionItem: ITreatmentPlanTemplateResponseObj, field: any) => {
        let updatedAnswerList = !_.isEmpty(this.props.targetValue) ? [...this.props.targetValue] : [];
        updatedAnswerList.push(suggestionItem.id);
        this.props.onTreatmentPlanSelect(suggestionItem, updatedAnswerList, field.targetFieldParentKey)
    }

    onSuggestionAdd = (suggestionItem: SuggestionItem, field: any) => {
        const targetField = this.props.question.answerList[0].targetField;
        let updatedAnswerList = !_.isEmpty(this.props.targetValue) ? [...this.props.targetValue] : [];
        let updatedItem: any = {};
        if (suggestionItem.recommendation && suggestionItem.recommendation.code) updatedItem.code = suggestionItem.recommendation.code;
        if (Array.isArray(targetField)) {
            targetField.map((item => {
                updatedItem[item.key] = item.targetValueIsObject ? { displayValue: suggestionItem.recommendation[item.recommendationValue], internalValue: suggestionItem.recommendation[item.recommendationValue] } : suggestionItem.recommendation[item.recommendationValue]
            }))
        }
        else {
            updatedItem = {
                [targetField]: suggestionItem.recommendation[targetField]
            }
        }
        updatedItem["fromTag"] = true;
        updatedAnswerList.push(updatedItem);
        this.props.updateHandler(updatedAnswerList, this.props.question.answerList[0].targetFieldParentKey);
    }

    getSuggestionList = (): SuggestionItem[] => {
        const targetFields = this.props.question.answerList[0].targetField;
        const recommendationKey = this.props.question.answerList[0].recommendationKey;

        // filter out primary target key incase of multiple targets
        const primaryTarget = targetFields.find((i: any) => i.primaryTarget === true);

        if (!_.isEmpty(this.props.suggestions) && !_.isEmpty(this.props.suggestions[recommendationKey])) {
            const suggestions = this.props.suggestions[recommendationKey];
            if (!_.isEmpty(this.props.targetValue) && primaryTarget) {
                let filteredSuggestions = (this.props.targetValue || []).filter((item: any) => item[primaryTarget.key] && item[primaryTarget.key].displayValue ? item[primaryTarget.key].displayValue : item[primaryTarget.key]);
                const alreadyFilledSuggestions = filteredSuggestions.map((item: any) => item[primaryTarget.key].displayValue ? item[primaryTarget.key].displayValue : item[primaryTarget.key]);
                return suggestions.filter((item: any) => alreadyFilledSuggestions.indexOf(item.displayValue ? item.displayValue : item) < 0);
            }
            return suggestions;
        }
        return [];
    }


    onCheckBoxChange = (event: React.ChangeEvent<HTMLInputElement>, key: string) => {
        localStorage.setItem(key, event.target.checked.toString())
        let updatedItem = { ...this.props.answer, [key]: event.target.checked }
        this.setState({
            isDisable: false
        })
        this.props.updateHandler(updatedItem, this.props.question.key);
    }

    renderLabel = (field: any) => {
        return <label className={"checkbox-label"}>{field.labelValue}</label>;
    }

    handleToggleSwitch = async (val: boolean, toggleSwitchObj: Question) => {
        if (toggleSwitchObj.trackingConfig) {
            const event = (toggleSwitchObj.trackingConfig.events || []).find((trEvent: ITrackingEvent) => trEvent.name === "click")
            if (event) {
                LocalStorageUtils.setClickEvents({
                    ...event.properties,
                    value: val
                })
            }
        }
        let updatedItem = { ...this.props.answer }
        updatedItem[toggleSwitchObj.key] = val
        await this.props.updateHandler(updatedItem, this.props.question.key)
        if (val && toggleSwitchObj.configuration.action) {
            switch (toggleSwitchObj.configuration.action) {
                case "clear":
                    toggleSwitchObj.configuration.linkedFieldKeys.map((linkedField: { key: string, value: string }) => {
                        this.props.updateTemplatedListData([], linkedField.key)
                    })
                    break
            }
        }
    }

    handleInputClick = (trackingConfig: ITrackingConfig, data?: { inputType: string, inputValue?: string }) => {
        if (trackingConfig) {
            const event = (trackingConfig.events || []).find((trEvent: ITrackingEvent) => trEvent.name === "click")
            if (event) {
                LocalStorageUtils.setClickEvents({
                    ...event.properties,
                    value: _.get(data, "inputValue", null),
                    inputType: _.get(data, "inputType", null)
                })
            }
        }
    }

    handleToggleListClick = (trackingConfig: ITrackingConfig, tagValue: string) => {
        if (trackingConfig) {
            const event = (trackingConfig.events || []).find((trEvent: ITrackingEvent) => trEvent.name === "click")
            if (event) {
                LocalStorageUtils.setClickEvents({
                    ...event.properties,
                    value: tagValue
                })
            }
        }
    }

    handleTemplatedListClick = (trackingConfig: ITrackingConfig, data?: { inputType: string, inputValue?: string | number, field?: string }) => {
        if (trackingConfig) {
            const event = (trackingConfig.events || []).find((trEvent: ITrackingEvent) => trEvent.name === "click")
            if (event) {
                LocalStorageUtils.setClickEvents({
                    ...event.properties,
                    field: _.get(data, "field", ""),
                    value: _.get(data, "inputValue", null),
                    inputType: _.get(data, "inputType", null)
                })
            }
        }
    }

    handleRichTextEditorClick = (trackingConfig: ITrackingConfig, data: { inputType: string, inputValue?: string | number, field?: string }) => {
        if (trackingConfig) {
            const event = (trackingConfig.events || []).find((trEvent: ITrackingEvent) => trEvent.name === "click")
            if (event) {
                LocalStorageUtils.setClickEvents({
                    ...event.properties,
                    field: _.get(data, "field", ""),
                    value: _.get(data, "inputValue", null),
                    inputType: _.get(data, "inputType", null)
                })
            }
        }
    }

    handleTypeaheadSuggestionSelect = (value: string, field: Question) => {
        const elem = { value, label: value }
        this.onTypeAheadSelect(elem, field)
    }

    onTemplatedListItemChange = (updatedValue: any, index: number, key: string) => {
        this.props.templatedListChange(updatedValue, index, key)
    }

    mapTypeQuestion = (type: Question) => {
        let value: any = null;
        let validationText = "";
        let { validations } = this.props;

        // check for dependant question and return null if true
        if (!_.isEmpty(type.dependentQues)) {
            let result
            // first check for value (if present)
            if (this.props.updatedObject && this.props.updatedObject[type.dependentQues.questionKey]) {
                result = this.props.updatedObject[type.dependentQues.questionKey]
                if (result && type.dependentQues.answerKey) {
                    result = result[type.dependentQues.answerKey]
                }
            } else {
                // second check for question default value (in case the value is not present)
                const dependantQuestionConfig = (this.props.allQuestionsConfig || []).find(question => question.key === type.dependentQues.questionKey)
                const answerConfig = _.get(dependantQuestionConfig, "answerList.0", null)
                result = _.get(answerConfig, "configuration.default", false)
            }
            if (result === true) return null
        }
        switch (type.type) {

            case QuestionType.LINE_DIVIDER:
                return <div className={"line-divider"} />

            case QuestionType.BOOLEAN_TOGGLE:
                value = this.props.answer ? [this.props.answer[type.key]] : [];
                if (AppUtils.isDefined(this.props.question.answerList[0].subKey)) {
                    if (!_.isEmpty(this.props.answer) && !_.isEmpty(this.props.answer[type.key]) && !_.isEmpty(this.props.answer[type.key][type.subKey])) value = [this.props.answer[type.key][this.props.question.answerList[0].subKey]];
                    else value = [];
                }
                return <ToggleList
                    keyName={type.key}
                    listItems={type.values}
                    selectedItems={value}
                    onSelectionChange={this.booleanToggleHandler}
                    type={type.type}
                    preventClickEvent={true}
                    isViewOnly={type.isViewOnly}
                    buttonClassName={type.class}
                    handleTagsClick={(event, tagValue) => this.handleToggleListClick(type.trackingConfig, tagValue)} />;

            case QuestionType.FREQUENCY: let unit = this.props.answer ? this.props.answer[type.key] ? this.props.answer[type.key].unit : "" : "";
                let count = this.props.answer ? this.props.answer[type.key] ? this.props.answer[type.key].count : "" : "";
                validationText = validations && validations[type.key] ? validations[type.key].errorMessage : "";
                return (
                    <Frequency
                        isFrequency={
                            type.frequency.isDuration
                                ? !type.frequency.isDuration
                                : true
                        }
                        unit={unit}
                        count={count}
                        dropdownItems={type.frequency.unit.list}
                        rootClass={"question"}
                        placeholder={type.frequency.count.placeholder}
                        onCountChange={e => this.countChangeHandler(e, type.key)}
                        validator={type.validator}
                        validationText={validationText}
                        onUnitChange={value =>
                            this.unitChangeHandler(value, type.key)
                        }
                        onDurationChange={value =>
                            this.frequencyChangeHandler(value, type.key)
                        }
                        useDropdownValue={!_.isEmpty(type.frequency.unit.list)}
                        supportDecimal={
                            AppUtils.isDefined(this.props.supportDecimal)
                                ? this.props.supportDecimal
                                : false
                        }
                    />
                );

            case QuestionType.INPUT:
                let name = type.placeholder;
                value = this.props.answer ? this.props.answer[type.key] : "";
                validationText = validations && validations[type.key] ? validations[type.key].errorMessage : "";
                return (
                    <Input
                        name={type.key}
                        keyName={this.props.doctorType === DoctorType.MIND_THERAPIST ? null : type.key}
                        disabled={this.props.question.isViewOnly}
                        validationText={validationText}
                        onChangeCallbackMeta={type.key}
                        value={value}
                        placeholder={type.placeholder}
                        suggestions={type.suggestions}
                        onClickHandler={(event, data) => this.handleInputClick(type.trackingConfig, data)}
                        onChange={(e, key) => this.onChangeHandler(e, key || type.key)}
                    />
                );

            case QuestionType.LABEL:
                return this.renderLabel(type);

            case QuestionType.SWITCH_TOGGLE: return this.renderSwitchToggle(type)


            case QuestionType.NUMERIC_INPUT:
                value = this.props.answer ? this.props.answer[type.key] : "";
                return (
                    <Input
                        name={type.key}
                        onChangeCallbackMeta={type.key}
                        value={value}
                        placeholder={type.placeholder}
                        onChange={this.onNumericChangeHandler}
                    />
                );

            case QuestionType.SELECT:
                value = this.props.answer ? this.props.answer[type.key] : "";
                validationText = this.props.validations && validations[type.key] ? validations[type.key].errorMessage : "";
                return <CustomSelect keyName={type.key} validationText={validationText} dropdownValues={type.list} selectedValue={value} defaultValue={type.placeholder} updateDropdownValue={this.selectHandler} className={""} />;

            case QuestionType.SELECTABLE_TOGGLE_LIST:
                value = this.props.answer && this.props.answer[type.key] ? this.props.answer[type.key] : [];
                let disableVal = this.props.question.isViewOnly;
                return <ToggleList listItems={type.values} keyName={type.key} isViewOnly={disableVal} selectedItems={value} onSelectionChange={this.allSelectToggleHandler} type={type.type} />;

            case QuestionType.TIME_CAPTURE: value = this.props.answer ? [this.props.answer[type.key]] : [];
                value = this.props.answer ? this.props.answer[type.key] : "";
                return <TimePicker value={AppUtils.getReadableTimeFromSeconds(value)} onChangeCallbackMeta={type.key} onTimeChange={this.allTimeChangeHandler} supportMeridiem={false} />;

            case QuestionType.TIME_RANGE_CAPTURE: value = this.props.answer ? [this.props.answer[type.key]] : [];
                value = this.props.answer ? this.props.answer[type.key] : "";
                return <Input name={type.key} onChangeCallbackMeta={type.key} value={AppUtils.getTimeInHoursFromSeconds(value)} placeholder={type.placeholder} onChange={this.onTimeRangeChangeHandler} />;

            case QuestionType.TEXTAREA: value = this.props.answer ? [this.props.answer[type.key]] : [];
                value = this.props.answer ? this.props.answer[type.key] : "";
                validationText = validations && validations[type.key] ? validations[type.key].errorMessage : "";
                return <div>
                    {
                        !_.isEmpty(validationText) &&
                        <span className="validation-error">
                            {validationText}
                        </span>
                    }
                    <TextAreaAutoResize widgetName={this.props.question.key} className={"textarea-input form-control"} rows={2} name={type.key} disabled={this.props.question.isViewOnly} value={value} placeholder={type.placeholder} onChange={(e: React.SyntheticEvent<HTMLTextAreaElement>) => this.onChangeHandler(e, type.key)} />
                </div>

            case QuestionType.TYPEAHEAD_SELECT:
                if (this.props.answer && this.props.answer.value && _.isArray(this.props.answer.value)) {
                    value = this.props.answer.value.map((item: any) => item.displayValue);
                } else {
                    value = [];
                }
                return <div className={"food-dislikes-wrapper-container"}>
                    <HorizontalTagsListViewTypeAhead tagsStringArray={value} onTagRemove={(value) => this.props.onListItemRemove(value, this.props.question.key)} name={type.key} value={this.props.typeAheadString}
                        placeholder={"Type here"} onTypeAheadChange={(evt) => this.props.onTypeHeadChangeHandler(evt, this.props.question.key)}
                        onTypeAheadSelect={(evt) => this.props.onTypeAheadSelect(evt, this.props.question.key)}
                    />
                </div>

            case QuestionType.LABEL_LIST:
                return type.type === "LABEL_LIST" ? <RenderLabel labelList={type.fields} /> : "";

            case QuestionType.SPACING_BAR:
                return <SpacingArea />

            case QuestionType.TEMPLATED_LIST_V2:
                const questionKey = this.props.question && this.props.question.key ? this.props.question.key : type.key;
                // if (this.props.updatedObject && !_.isEmpty(type.dependentQues)) {
                //     let result = this.props.updatedObject[type.dependentQues.questionKey]
                //     if (result && type.dependentQues.answerKey) {
                //         result = result[type.dependentQues.answerKey]
                //     }
                //     if (result === true) return null
                // }
                return (
                    <FlowContext.Consumer>
                        {flowContext => (
                            <EditorAndViewContainer
                                metaData={this.props.metaData}
                                savedItems={this.props.answer || []}
                                updateData={(updatedItem: any, index: number) => this.props.templatedListChange(updatedItem, index, questionKey)}
                                viewTemplateName={this.props.subSectionKey}
                                viewTemplateProps={{}}
                                widgetConfiguration={this.props.question}
                                removeItem={(index: number) => this.props.templatedListRemoved(index, questionKey)}
                                updateList={(data: { item: any, mode: FormItemMode }[]) => this.props.updateTemplatedListData(data, this.props.question.key)}
                                allSuggestions={this.props.suggestions}
                                onAddNewItem={this.props.onAddNewItem}
                                validationSchema={this.props.validationSchema}
                                fetchDataOnSelect={this.props.fetchDataOnSelect}
                                appointmentSchedule={this.props.appointmentSchedule}
                                flowContext={flowContext}
                                getSuggestionsSequentially={this.props.getSuggestionsSequentially}
                                handleListItemClick={(event: any, data) => this.handleTemplatedListClick(type.trackingConfig, data)}
                                hideDeleteAndAddOption={this.props.hideDeleteAndAddOption}
                            />
                        )}
                    </FlowContext.Consumer>
                )


            case QuestionType.TEMPLATED_LIST: {
                let listItems: any;
                try {
                    listItems = this.props.answer ? this.props.answer.map((obj: any, index: any) => { return { "item": obj } }) : [];
                }
                catch (e) {
                    listItems = [];
                }

                let key = this.props.question && this.props.question.key ? this.props.question.key : type.key;
                const { templatedListConfiguration, showHeaderOnFields } = type;
                let headersInfo: any[] = [];
                this.getHeadersInfo(type.fields, headersInfo);

                return <div className="physical-assessment-editor" >
                    {type.listHeader && type.listHeader.trim() && <div className={"questionnaire-header"}>{type.listHeader}</div>}
                    {headersInfo.length > 0 && !showHeaderOnFields && <TemplatedListHeaders headersInfo={headersInfo} />}
                    <TemplatedList
                        templateName={"genericItemEditor"}
                        commonProps={{ fields: type.fields, showHeaderOnFields }}
                        defaultItem={{ item: this.createNewFields(type) }}
                        listItems={listItems}
                        validations={validations}
                        isViewOnly={this.props.question.isViewOnly}
                        onItemRemove={(index: number) => this.props.templatedListRemoved(index, key)}
                        onItemChange={(updatedValue, index) => this.props.templatedListChange(updatedValue, index, key)}
                        templatedListValidations={(value, index) => this.props.templatedListValidations(value, index, key)}
                        hideRemoveBtn={_.get(templatedListConfiguration, "hideRemoveBtn")}
                        autoAddNewRow={_.get(templatedListConfiguration, "autoAddNewRow")}
                        addRowText={_.get(templatedListConfiguration, "addRowText")}
                        preventRowAddition={_.get(templatedListConfiguration, "preventRowAddition")}
                        questionKey={this.props.question.key}
                        handleListItemClick={(event: any, data) => this.handleTemplatedListClick(type.trackingConfig, data)}
                    />

                </div>
            }
            case QuestionType.TEMPLATED_LIST_V3: {
                let listItems: any;
                try {
                    listItems = this.props.answer ? this.props.answer.map((obj: any, index: any) => { return { "item": obj } }) : [];
                }
                catch (e) {
                    listItems = [];
                }

                let key = this.props.question && this.props.question.key ? this.props.question.key : type.key;
                const { templatedListConfiguration, showHeaderOnFields } = type;
                // let headersInfo: any[] = [];
                // this.getHeadersInfo(type.fields, headersInfo);

                return <div className="physical-assessment-editor new-history-section" >
                    {/* {type.listHeader && type.listHeader.trim() && <div className={"questionnaire-header"}>{type.listHeader}</div>}
                    {headersInfo.length > 0 && !showHeaderOnFields && <TemplatedListHeaders headersInfo={headersInfo} />}
                     */}

                    <TemplatedListV3
                        templateName={"genericItemEditor"}
                        commonProps={{ fields: type.fields, showHeaderOnFields }}
                        defaultItem={{ item: this.createNewFields(type) }}
                        listItems={listItems}
                        validations={validations}
                        isViewOnly={this.props.question.isViewOnly}
                        onItemRemove={(index: number) => this.props.templatedListRemoved(index, key)}
                        onItemChange={(updatedValue, index) => this.onTemplatedListItemChange(updatedValue, index, key)}
                        templatedListValidations={(value, index) => this.props.templatedListValidations(value, index, key)}
                        hideRemoveBtn={_.get(templatedListConfiguration, "hideRemoveBtn")}
                        autoAddNewRow={_.get(templatedListConfiguration, "autoAddNewRow")}
                        addRowText={_.get(templatedListConfiguration, "addRowText")}
                        preventRowAddition={_.get(templatedListConfiguration, "preventRowAddition")}
                        questionKey={this.props.question.key}
                        handleListItemClick={(event: any, data) => this.handleTemplatedListClick(type.trackingConfig, data)}
                    />
                </div>
            }

            case QuestionType.PAIN_SCALE: {
                let scaleRange = AppUtils.getPainScale();
                const list = scaleRange.map((num, i) =>
                    <div key={i}> {num} </div>
                );
                let { question, answer } = this.props;
                let key = question && question.key;
                let value = answer ? answer : 0
                return <div className="pain-history-editor">
                    <div className="slider-row">
                        <div className="column">
                            <div className="scale-heading">PAIN SCALE</div>
                        </div>
                    </div>
                    <div className="row">
                        <div>
                            <SliderComponent minValue={0} maxValue={10} value={value} updateHandler={(value) => this.onSliderChange(value, key)} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="range-list">
                            {list}
                        </div>
                    </div>
                </div>
            }

            case QuestionType.QUESTIONNAIRE: {
                return type.data && type.data.map((dataObj: any, index: number) => {
                    let key = dataObj.key;
                    let answer = key && this.props.answer && this.props.answer[key] ? this.props.answer[key] : null;
                    validationText = validations && validations[type.key] ? validations[type.key] : null;

                    return <Questionnaire
                        key={index}
                        question={dataObj}
                        answer={answer}
                        updateHandler={(value, subkey) => this.updateHandler(value, subkey, this.props.question.key)}
                        hideComment={dataObj.hideComment ? dataObj.hideComment : true}
                        validationText={validationText}
                        validationHandler={this.props.validationHandler}
                        isViewOnly={this.props.question.isViewOnly}
                        modalHeaders={this.props.modalHeaders}
                    />
                })
            }

            case QuestionType.TYPEAHEAD: {
                let displayValue = this.props.answer ? this.props.answer[type.displayKey] : "";
                validationText = validations && validations[type.key] ? validations[type.key] : null;
                const suggestions: IStaticDataValue[] = (type.suggestions || []).map((item: string) => ({ displayValue: item, internalValue: item }))
                return <div className={"questionnaire-typeahead-wrapper"}>
                    {!_.isEmpty(suggestions) && <div className={"cs-suggestions-container"}>
                        <ToggleButtonList
                            type={QuestionType.BOOLEAN_TOGGLE}
                            handleTagsClick={(event, tagValue) => this.handleInputClick(type.trackingConfig, { inputType: "Tags", inputValue: tagValue })}
                            listItems={suggestions}
                            selectedItems={[]}
                            onSelectionChange={(value) => this.handleTypeaheadSuggestionSelect(value as string, type)}
                        />
                    </div>}
                    <TypeAhead
                        name={type.key}
                        value={displayValue || ""}
                        placeholder={type.placeholder}
                        onTypeAheadChange={(input: any) => this.onTypAheadChange(input, type)}
                        onTypeAheadSelect={(elem: any) => this.onTypeAheadSelect(elem, type)}
                        onClickHandler={(event, data) => this.handleInputClick(type.trackingConfig, data)}
                    />
                </div>
            }

            case QuestionType.QUESTIONNAIRE_LIST: {
                let listItems: any = this.props.answer ? this.props.answer[type.key] : [];
                return <QuestionnaireList
                    templatedListChange={this.props.templatedListChange}
                    templatedListRemoved={this.props.templatedListRemoved}
                    templatedListValidations={this.props.templatedListValidations}
                    listItems={listItems}
                    type={type}
                    validations={validations}
                    updateHandler={this.updateListHandler}
                    updateQuestionnaireList={this.updateQuestionnaireList}
                    isViewOnly={this.props.question.isViewOnly}
                />
            }

            case QuestionType.SUGGESTION: {
                let suggestions = !_.isEmpty(this.props.suggestions) ? this.getSuggestionList() : null;
                return !_.isEmpty(suggestions) ? (
                    <div>
                        <SuggestionTagsContainer rootClass={"past-conditions"} suggestions={suggestions}
                            onTagSelect={(selectedValue: any) => this.onSuggestionAdd(selectedValue, type)} />
                    </div>
                ) : null

            }

            case QuestionType.CHECKBOX: {
                value = this.props.answer ? this.props.answer[type.key] : false;
                return <input type="checkbox" value={value} disabled={this.props.question.isViewOnly}
                    className={`yesOrNoButton checkSelect ${value ? "active" : ""}`}
                    onChange={(event) => this.onCheckBoxChange(event, type.key)} checked={value}
                />
            }

            case QuestionType.TOGGLE_SWITCH: {
                const toggleSwitchObj = this.props.question.answerList[0];
                const enableStatus = this.props.answer && AppUtils.isDefined(this.props.answer[toggleSwitchObj.key]) ? this.props.answer[toggleSwitchObj.key] : toggleSwitchObj.configuration.default;
                return <ToggleSwitch widgetName={this.props.question.key} label={toggleSwitchObj.configuration.label || ""} secondLabel={toggleSwitchObj.configuration.secondLabel || ""} enabled={enableStatus} onClick={(val: boolean) => this.handleToggleSwitch(val, type)} />
            }

            case QuestionType.NOTES: {
                value = this.props.answer ? this.props.answer[type.key] : "";
                return <div className={"notes-editor"}>
                    <div className={"chief-complaints-notes  collapsible-card"}>
                        <label className={"brandon notes-editor-primary-label"}>{type.label}</label>
                        <br />
                        {type.secondaryLabel && <label className={"brandon notes-editor-secondary-label"}>{type.secondaryLabel}</label>}
                        {this.props.doctorType === DoctorType.MIND_THERAPIST ? (
                            <RichTextEditor name={type.key} value={value} onChange={(value: string) => { this.onChangeRichText(value, type.key) }} />
                        ) : (
                                <TextareaAutosize rows={4} name={type.key} label={type.label} onChange={(e) => this.onChangeHandler(e, type.key)}
                                    value={value} placeholder={type.placeholder} onBlur={(event) => this.onBlur(event, type.key)} onKeyDown={this.onKeyDown} />
                            )}
                    </div>
                </div>

            }

            case QuestionType.RICH_TEXT: {
                value = this.props.answer && this.props.answer[type.key]
                const usedSuggestions = _.get(this.props.usedSuggestionsForEditorMap, `${this.props.subSectionKey}.${this.props.question.key}`, [])
                const filteredSuggestions = !_.isEmpty(usedSuggestions)
                    ? type.suggestions.filter((suggestion: string) => usedSuggestions && usedSuggestions.indexOf(suggestion) < 0)
                    : type.suggestions
                return <React.Fragment>
                    {type.listHeader && <div className={"questionnaire-header"}>{type.listHeader}</div>}
                    <RichTextEditor
                        name={type.key}
                        value={value || ""}
                        suggestions={filteredSuggestions}
                        updateSelectedSuggestions={(val: string) => this.props.addUsedSuggestionForEditor(this.props.subSectionKey, this.props.question.key, val)}
                        handleClick={(data) => this.handleRichTextEditorClick(type.trackingConfig, data)}
                        onChange={(value: string) => { this.onChangeRichText(value, type.key) }}
                        onTypeAheadChange={(input: any) => this.onTypAheadChange(input, type, false)}
                    />
                </React.Fragment>
            }

            case QuestionType.TABLE: {
                let answer = this.props.answer;
                return answer && answer.map((row: any) => {
                    return <div className="patient-diagnosis-data-editor">
                        <div className={"patient-data-summary"}>
                            <table>
                                <tbody>
                                    <tr>
                                        {
                                            row.map((data: any, index: number) => {

                                                return <td className={index > 0 ? "value" : "label"} key={data + index}>{data}</td>
                                            })
                                        }
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                    </div>
                })
            }

            case QuestionType.LINK: {
                return this.props.question.answerList.map((data: any) => {
                    return <div>
                        {
                            !_.isEmpty(data.pastDataKey) && !this.state.isActiveMedicationVisible &&
                            <a onClick={() => this.setState({ isActiveMedicationVisible: true })}>{data.value}</a>
                        }
                        {
                            this.state.isActiveMedicationVisible &&
                            <div className={"active-medications"}>
                                <div className={"active-medications-header brandon-bold"}>
                                    {data.placeholder}
                                    <a onClick={() => this.setState({ isActiveMedicationVisible: false })}>(Hide)</a>
                                </div>
                                {
                                    this.props.answer &&
                                    this.props.answer.map((data: any) => {
                                        return <div className={"medicine-row-item"} tabIndex={0} onClick={() => { this.onPastDataClick(data.originalObject) }}>
                                            {
                                                Object.keys(data).map((index: any) => {
                                                    return !isNaN(index) && <div className={"medicine-name medicine-col"}>
                                                        <div className={"brand-name"}>{data[index].displayValue}</div>
                                                        <div className={"molecule-name"}>{data[index].helperText}</div>
                                                    </div>
                                                })
                                            }
                                        </div>
                                    })
                                }
                            </div>


                        }
                        <div>
                        </div>
                    </div>

                })

            }

            case QuestionType.ADVANCED_DURATION: {
                const durationUnit = this.props.answer && this.props.answer[type.key] && this.props.answer[type.key].unit ? this.props.answer[type.key].unit : null;
                const durationCount = this.props.answer && this.props.answer[type.key] && this.props.answer[type.key].count ? this.props.answer[type.key].count : null;
                return <AdvancedDurationComponent
                    unit={durationUnit}
                    count={durationCount}
                    rootClass={""}
                    toggleValues={type.toggleValues}
                    selectionData={type.selectionData}
                    unitList={[]}
                    onDurationChange={(duration: IFrequency) => this.handleAdvancedDurationChange(duration, type)}
                />
            }

            case QuestionType.TREATMENT_PLAN_LIST: {
                const treatmentPlanObject = this.props.question.answerList[0];
                let suggestions: Array<ITreatmentPlanTemplateResponseObj> = !_.isEmpty(this.props.suggestions) ? this.getSuggestionList() : []
                if (this.props.targetValue) {
                    suggestions = suggestions.filter((sugg: ITreatmentPlanTemplateResponseObj) => {
                        return (_.isEmpty(this.props.targetValue.find((elem: string) => elem === sugg.id)))
                    })
                }
                return (
                    <TreatmentPlanComponent
                        widgetName={this.props.question.key}
                        name={treatmentPlanObject.key}
                        listItems={suggestions}
                        emptyText={this.props.emptyText}
                        onListItemClick={(selectedItem: any) => this.onTemplateAdd(selectedItem, type)}
                        onUndoApplyTreatmentPlan={this.props.onUndoApplyTreatmentPlan}
                        isPastPrescriptionFlow={false}
                    />)
            }
            case QuestionType.PAST_PRESCRIPTION_LIST: {
                const treatmentPlanObject = this.props.question.answerList[0];
                const pastCons: any = !_.isEmpty(this.props.pastConsultaions) ?
                    this.props.pastConsultaions.filter((pastCons: any) => {
                        return pastCons.doctorId == this.props.doctorProfile.id
                    })
                    : [];
                let suggestions: Array<ITreatmentPlanTemplateResponseObj> = EHRRequestMapper.convertPastPrescriptionsToTemplateData(pastCons);
                if (this.props.targetValue) {
                    suggestions = suggestions.filter((sugg: ITreatmentPlanTemplateResponseObj) => {
                        return (_.isEmpty(this.props.targetValue.find((elem: string) => elem === sugg.id)))
                    })
                }
                return (
                    <TreatmentPlanComponent
                        widgetName={this.props.question.key}
                        name={treatmentPlanObject.key}
                        listItems={suggestions}
                        emptyText={this.props.emptyText}
                        onListItemClick={(selectedItem: any) => this.onTemplateAdd(selectedItem, type)}
                        onUndoApplyTreatmentPlan={this.props.onUndoApplyTreatmentPlan}
                        isPastPrescriptionFlow={true}
                    />)
            }
            default: return null;
        }
    }

    handleAdvancedDurationChange = (duration: any, type: any) => {
        let updatedAnswer = { ...this.props.answer };
        if (duration && duration.unit && (duration.unit === MedicineFrequencyType.SOS || duration.unit === "STAT")) {
            duration.count = null
        }
        updatedAnswer[type.key] = duration;
        this.props.updateHandler(updatedAnswer, this.props.question.key);
    }

    updateListHandler = (value: any, key: string, index: number) => {
        let questionKey = this.props.question.key;
        let updatedInfo = { ...this.props.answer }
        if (!updatedInfo[key]) {
            updatedInfo[key] = [];
        }
        updatedInfo[key][index] = value;
        this.props.updateHandler(updatedInfo, questionKey);
    }

    setToggleState = (key: boolean) => {
        this.setState({ defalutToggleSelect: key })
    }

    renderToggle = (type: any) => <ToggleSelect title={type.checkBoxHeading} isHidden={listValue} />

    renderSwitchToggle = (type: any) => {
        const switchToggleProps = {
            title: type.displayHeading,
            label: this.props,
            onClick: () => this.onToggleSelect(this.state.defalutToggleSelect, type.key),
            isHidden: this.state.defalutToggleSelect
        }
        return (
            <ToggleSelect {...switchToggleProps} />
        )
    }


    updateQuestionnaireList = (listItems: any[], key: string) => {
        let answer = { ...this.props.answer };
        answer[key] = listItems;
        this.props.updateHandler(answer, this.props.question.key);
    }

    render() {
        let { question, answer } = this.props;
        let templatedCls = question.answerList && question.answerList.find((type) => {
            return ((type.type === QuestionType.TEMPLATED_LIST) || (type.type === QuestionType.TEMPLATED_LIST_V3))
        })
            ? "top-padding" : "";
        let questionnaireCls = question.answerList && question.answerList.find((type) => type.type === QuestionType.QUESTIONNAIRE) ? "display-type" : "";
        let { collapsible } = question;
        let component = <div className={`questionnaire-component ${questionnaireCls} ${AppUtils.isDefined(question.class) ? question.class : ""}`}>
            {!collapsible && question.questionTitle && question.questionTitle.trim() && <div className={`question-text in-blk ${templatedCls}`}>
                {question.questionTitle}
            </div>}
            {question.imgUrl && <div className="image-container">
                <img className="image" src={question.imgUrl} />
            </div>}

            <div className={`dynamic-question ${question.class || "in-blk"} ${question.imgUrl ? "half-width" : ""}`} style={{ minWidth: this.props.minWidth }}>
                {question.answerList && question.answerList.map((componentConfig: any, index: number) => {
                    // const headers = type.fields ? type.fields.map((field :any)=>  ({label: field.header, display: field.header}) ): [];
                    let cls = componentConfig.textSize ? componentConfig.textSize + ` in-blk ${componentConfig.type}` : `in-blk col-50 ${componentConfig.type}`;
                    return <div key={index} className={componentConfig.type === QuestionType.PAIN_SCALE ? "pain-scale-container" : cls}>
                        {this.mapTypeQuestion(componentConfig)}
                    </div>

                })}
            </div>
            {!this.props.hideComment && <div className="default-question in-blk align-middle">
                <TextAreaAutoResize
                    name={"questionnaire-textarea"}
                    className={"textarea-input form-control"}
                    value={!_.isEmpty(answer) && AppUtils.isDefined(answer.comment) ? answer.comment : ""}
                    placeholder={"Add comment"}
                    onChange={this.onChangeHandler}
                    rows={2}
                />
            </div>}
        </div>
        if (collapsible)
            return <CollapsiblePanel>
                <div className="collapsible-heading">{question.title}</div>
                {component}
            </CollapsiblePanel>
        return component
    }
}

const mapDispatchToProps = (dispatch: any): IMapDispatch => {
    return {
        getTypeAheadData: (input: string, typeAheadConfig: any) => {
            return GenericActions.getTypeAheadData(input, typeAheadConfig);
        },
        addUsedSuggestionForEditor: (subSectionKey: string, questionKey: string, val: string) => OngoingConsultationActions.addUsedSuggestionForEditor(dispatch, subSectionKey, questionKey, val)
    }
}

const mapStateToProps = (state: IAppState): QuestionnaireStateProps => {
    return {
        doctorType: state.ongoingConsultation?.appointmentSchedule?.doctorType,
        usedSuggestionsForEditorMap: state.ongoingConsultation.usedSuggestionsForEditorMap,
        pastConsultaions: state.ongoingConsultation.pastPrescriptions,
        doctorProfile: state.doctorProfile
    }
}

export default connect<QuestionnaireDispatchProps, void, QuestionnaireProps>(mapStateToProps, mapDispatchToProps)(Questionnaire);